
define('app/activation/actApp',[
	'jquery',
	'underscore',
	'backbone',
	'unknown/models/activationModel',
	'unknown/views/actView'
], function($, _, Backbone, ActivationModel, ActView){
	var initialize = function(){
		var resource = "activations";		
		var pathArray = window.location.pathname.split('/');
		var resourceIndex = -1;
		var actKey = null;
		for (var i = 0; i < pathArray.length; i++ ) {
			if(resourceIndex == -1 && pathArray[i] == resource){
				resourceIndex = i;
			} else if(resourceIndex != -1 && i == resourceIndex + 1){
				actKey = pathArray[i];
			}
		}
		
		var actModel = new ActivationModel();
		var actView = new ActView({actModel: actModel});
		actView.render();
		
		if(actKey){
			$("#actKeyInput").val(actKey);
			actModel.set("key", actKey);
			actView.processKey();
		}
	};
	
	return {
		initialize: initialize
	};
});